export default {
  quantities: ['10', '25', '50', '100'],
  part_number: '',
  revision: '',
  number_of_layers: '2',
  board_length: '',
  board_width: '',
  silkscreen_sides: 'Top Side',
  blind_buried_hole: 'None',
  material_type: 'FR4',
  finish_plating: 'Leaded Solder',
  gold_fingers: '0',
  material_thickness: '0.062',
  gold_thickness: 'Au<10',
  copper_inners: '1 oz',
  copper_outers: '1 oz',
  min_trace_space: 0.006,
  solder_sides: 'Both Sides',
  ezq_job_number: '',
  solder_color: 'green',
  silkscreen_color: 'White',
  smallest_hole_size: 0.01,
  pitch: 0.0,
  array_x_qty: '',
  array_y_qty: '',
  tab_rout: '0',
  scoring: '0',
  has_advanced_specs: '0',
  plated_slots: '0',
  counterbores: '0',
  controlled_impedance: '0',
  plated_edges: '0',
  countersink: '0',
  controlled_dielectric: '0',
};
